module.exports = __webpack_public_path__ + "static/media/edit_icon_white.a3d616c3.svg";